import styled, { css, keyframes } from 'styled-components';

import { media } from '~/src/styles-constants';

import { HideTextButton } from '../Input/layout';

export const Container = styled.div`
  margin-bottom: 10px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;

  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputRowChildren = styled.div<{ $hasError: boolean; $showIndicator?: boolean }>`
  flex: 1;
  line-height: 0;

  ${HideTextButton} {
    right: ${({ $showIndicator }) => `${$showIndicator ? '30px;' : '9px'}`};
  }

  ${({ $hasError }) =>
    $hasError
      ? css`
          && > input {
            border-color: ${({ theme }) => theme.palette.error};

            &:focus {
              border-color: initial;
            }
          }
        `
      : ''}
`;

const errorIndicatorKeyframe = keyframes`
{
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const ValidationIndicator = styled.span<{
  indicator: 'valid' | 'error';
}>`
  position: absolute;

  right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 25px;
  height: 25px;
  margin-left: -35px;

  border-radius: 13px;
  color: ${({ theme }) => theme.palette.common.PRIMARY};

  animation: ${errorIndicatorKeyframe} 0.2s ease;

  z-index: 2;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
  margin-top: 16px;

  & > * {
    width: 100%;
    padding: 0 10px;
  }

  ${media.M`
    margin-top: 22px;
    & > * {
      width: auto;
      flex: 1 1 50%;
    }
  `}
`;
